import {gsap} from 'gsap';

export default function animations() {

  if( $('.hero').length ){
    const tl = gsap.timeline();
    tl.from('.hero-text__subtitle, .hero-text__title, .hero-text__description', {opacity: 0, duration: 0.70, stagger: 0.1, ease: 'power2.out', y: -80, delay: 0.4});
    tl.from('.hero-text__buttons', {opacity: 0, duration: 0.70, stagger: 0.1, ease: 'power2.out', y: -80, delay: 0});
  }

}



// WEBPACK FOOTER //
// ./scripts/modules/animations.js